import api from "./api";
import getHistoryParams from "../utils/historyParams";

const HISTORY_ENDPOINT = "partner/prescription/history";
const DEFAULT_LIMIT = 10;

// Carimba o offset de origem em cada prescrição para que o download consiga
// refazer exatamente a página dela e obter um pdf_access novo (o token expira
// enquanto a lista fica aberta), sem varrer o histórico inteiro.
const mapPrescriptions = (data, offset) =>
  data?.map((prescription) => ({
    ...prescription.attributes,
    id: prescription.id,
    historyOffset: offset,
  }));

const buildPagination = (meta, currentOffset) => {
  const limit = Number(meta?.limit) || DEFAULT_LIMIT;
  const total = Number(meta?.total) || 0;
  const nextOffset = currentOffset + limit;

  return {
    hasNext: nextOffset < total,
    nextOffset,
  };
};

// Histórico via POST: credenciais e paginação vão no corpo, nunca na URL.
// page[offset]/page[limit] são enviados como string para casar com a validação
// da API (ctype_digit). Devolve prescrições já normalizadas e a paginação,
// fonte única de verdade para o contexto e para o refresh de pdf_access.
const fetchHistoryPage = async ({ offset = 0, limit = DEFAULT_LIMIT } = {}) => {
  const response = await api.post(HISTORY_ENDPOINT, {
    ...getHistoryParams(),
    page: {
      offset: String(offset),
      limit: String(limit),
    },
  });

  const { data, meta } = response?.data || {};

  return {
    prescriptions: mapPrescriptions(data, offset),
    pagination: buildPagination(meta, offset),
  };
};

export default fetchHistoryPage;
